"use client";

import { LinearGradient } from "expo-linear-gradient";
import { memo } from "react";
import { GATHERING_NOT_READY_POPUP } from "src/api/featureFlags";
import GatheringViewMethod from "src/api/graphql/__generated__/enums/GatheringViewMethod";
import { NativeHeaderGradient } from "src/components/GatheringHeader";
import MarkGatheringViewed from "src/components/MarkGatheringViewed";
import NativeBackgroundColorWrapper from "src/components/NativeBackgroundColorWrapper";
import { useGatheringStore } from "src/contexts/GatheringContext";
import usePalette from "src/hooks/usePalette";
import usePromptReview from "src/hooks/usePromptReview";
import lazy from "src/swsh-native/lazy";
import FileUploadAreaWrapper from "./components/FileUploadAreaWrapper";
import FileUploadArea from "./components/FileUploadDisplay";
import FilterLoading from "./components/FilterLoading";
import GatheringHomeAddonAudioPlayer from "./components/GatheringHomeAddonAudioPlayer";
import GatheringHomeContent from "./components/GatheringHomeContent";
import GatheringHomeFooter from "./components/GatheringHomeFooter";
import GatheringHomeNavBar from "./components/GatheringHomeNavBar";
import GatheringNotReadyPopUp from "./components/GatheringNotReadyPopUp";
import PresentSearchParamModal from "./components/PresentSearchParamModal";
import SyncGatheringWebData from "./components/SyncGatheringWebData";
import useIsFilterInitializing from "./hooks/useIsFilterInitializing";

const MissingFacialRecognitionPopUp = lazy(
	() => import("./components/MissingFacialRecognitionPopUp"),
	{
		loading: () => null,
	},
);

const GatheringHome = () => {
	const gatheringId = useGatheringStore((state) => state.gatheringId);

	const { showFilterLoading, forceDismiss } = useIsFilterInitializing();
	const { tertiary } = usePalette();
	usePromptReview("unmount");

	return (
		<NativeBackgroundColorWrapper>
			<GatheringHomeAddonAudioPlayer />
			<MarkGatheringViewed gatheringId={gatheringId} method={GatheringViewMethod.Main} />
			<SyncGatheringWebData />
			<PresentSearchParamModal />
			{GATHERING_NOT_READY_POPUP && <GatheringNotReadyPopUp />}
			<MissingFacialRecognitionPopUp />
			<FileUploadAreaWrapper>
				<GatheringHomeNavBar />
				<GatheringHomeContent />
				<GatheringHomeFooter />
				<FileUploadArea />
				<LinearGradient
					colors={[tertiary, "transparent"]}
					style={{
						position: "absolute",
						top: 0,
						width: "100%",
						height: 50,
					}}
				/>
				<NativeHeaderGradient />
			</FileUploadAreaWrapper>
			<FilterLoading forceDismiss={forceDismiss} enabled={showFilterLoading} />
		</NativeBackgroundColorWrapper>
	);
};
export default memo(GatheringHome);
